<template>
  <div class="invoice-skeleton">
    <div class="skeleton-header">
      <div class="skeleton-line short"></div>
    </div>
    <div class="skeleton-body">
      <div class="skeleton-line"></div>
      <div class="skeleton-line"></div>
      <div class="skeleton-line medium"></div>
      <div class="skeleton-line"></div>
      <div class="skeleton-line short"></div>
      <div class="skeleton-line"></div>
      <div class="skeleton-line medium"></div>
      <div class="skeleton-line"></div>
      <div class="skeleton-line short"></div>
    </div>
    <div class="skeleton-footer">
      <div class="skeleton-box"></div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}

@keyframes fade {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.6;
  }
}

.invoice-skeleton {
  padding: 2rem;
  background: white;
  border-radius: 8px;
  margin: 1rem;
  min-height: 600px;
}

.skeleton-header {
  border-bottom: 1px solid #e2e8f0;
  padding-bottom: 1rem;
  margin-bottom: 2rem;
}

.skeleton-body {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 2rem;
}

.skeleton-line {
  height: 16px;
  background: linear-gradient(
    90deg,
    #e2e8f0 0%,
    #eef2f6 20%,
    #f1f5f9 40%,
    #eef2f6 60%,
    #e2e8f0 100%
  );
  background-size: 200% 100%;
  animation:
    shimmer 2s ease-in-out infinite,
    fade 3s ease-in-out infinite;
  border-radius: 4px;
  width: 100%;

  &.short {
    width: 40%;
  }

  &.medium {
    width: 70%;
  }
}

.skeleton-footer {
  margin-top: 3rem;
}

.skeleton-box {
  height: 200px;
  background: linear-gradient(
    90deg,
    #e2e8f0 0%,
    #eef2f6 20%,
    #f1f5f9 40%,
    #eef2f6 60%,
    #e2e8f0 100%
  );
  background-size: 200% 100%;
  animation:
    shimmer 2s ease-in-out infinite,
    fade 3s ease-in-out infinite;
  border-radius: 8px;
}
</style>
